export default function Selector(state, property) {
  const selectors = {
    user: (s) => s.main.user || {},
  };
  return selectors[property](state);
}
